import React, { Component, Fragment } from 'react';
import { Redirect } from 'react-router-dom';
import { Mutation } from 'react-apollo';

import { Box, Flex, Text } from 'Components/Base';
import { FONT_SIZE } from 'Components/Theme';
import { getCurrentEducationYear } from 'Util/DateUtils';
import { QueryComponent } from 'GraphQL';
import {
  profile as queryProfile,
  profileWithLocationCode as queryProfileAndLocation,
} from 'GraphQL/query/mockSchool/LinkSchool.query';
import { linkMockExamStudent } from 'GraphQL/mutation/mockSchool/LinkMockExamStudent.mutation';
import { studentProfileWithExamRound } from 'GraphQL/query/MockExamManage.query';

import AppContainer from '../AppContainer';

import LinkSchoolErrorContact from './Components/LinkSchoolErrorContact';
import LinkSchoolData from './Components/LinkSchoolData';

const Toolbar = ({ roundTitle }) => (
  <Flex flexDirection="column">
    <Text fontSize={[FONT_SIZE.large]} mr={1}>
      Mock Exam เชื่อมระบบโรงเรียน
    </Text>

    <Text>
      {`รอบ: `}
      <Text fontWeight="bold" style={{ display: 'inline' }}>
        {roundTitle}
      </Text>
    </Text>
  </Flex>
);

export default class LinkSchool extends Component {
  render() {
    const { menus, match, history } = this.props;
    const {
      params: { roundCode: encodedRoundCode = '', locationCode = '' },
    } = match;
    const year = getCurrentEducationYear();

    const roundCode = decodeURIComponent(encodedRoundCode);

    const query = locationCode ? queryProfileAndLocation : queryProfile;

    let variables = { educationYear: year, roundCode };
    if (locationCode) {
      variables = {
        ...variables,
        locationCode,
      };
    }

    return (
      <AppContainer menus={menus}>
        <QueryComponent query={query} variables={variables}>
          {data => {
            const {
              myProfile: { userDetails = {}, educationProfiles },
              mockExamSchool,
              mockExamSchoolRound,
              mockExamStudentProfile,
            } = data || {};

            const locationName = mockExamSchool ? mockExamSchool.locationName : '';
            return (
              <Mutation
                mutation={linkMockExamStudent}
                awaitRefetchQueries
                refetchQueries={[
                  {
                    query: studentProfileWithExamRound,
                    variables: { roundCode },
                  },
                ]}
              >
                {(linkStudent, { data, error }) => {
                  let openErrorModal = false;
                  let errorOnlink = null;
                  if (data) {
                    if (data.linkMockExamStudent.success) {
                      return <Redirect to={`/school/manage-mock-exam/${encodedRoundCode}`} />;
                    } else {
                      errorOnlink = {
                        error: data.linkMockExamStudent.error,
                        code: data.linkMockExamStudent.code,
                        message: data.linkMockExamStudent.message,
                      };
                      openErrorModal = true;
                    }
                  }

                  const hasActiveRound = mockExamSchoolRound && mockExamSchoolRound.isActive;

                  if (hasActiveRound && mockExamSchool !== null) {
                    return (
                      <Fragment>
                        <Toolbar roundTitle={mockExamSchoolRound.title || ''} />
                        <LinkSchoolData
                          studentProfile={userDetails}
                          educationProfile={educationProfiles || ''}
                          roundCode={roundCode}
                          locationCode={locationCode}
                          mutation={linkStudent}
                          locationName={locationName}
                          roundTitle={mockExamSchoolRound.title}
                          openErrorModal={openErrorModal}
                          error={errorOnlink}
                          mockExamStudentProfile={mockExamStudentProfile}
                          history={history}
                        />
                      </Fragment>
                    );
                  }

                  if (!hasActiveRound || !mockExamSchoolRound.enabledSchoolRegistration) {
                    return (
                      <LinkSchoolErrorContact
                        errorText={`ไม่อนุญาตให้เชื่อมรอบรหัส ${roundCode}`}
                      />
                    );
                  }

                  return (
                    <LinkSchoolErrorContact errorText={`ไม่พบโรงเรียนที่มีรหัส ${locationCode}`} />
                  );
                }}
              </Mutation>
            );
          }}
        </QueryComponent>
      </AppContainer>
    );
  }
}
